module.exports = __webpack_public_path__ + "static/img/songshuAI_logo.1d4c0b3a.png";